import React from 'react';
import RecordFormCreate from './RecordFormCreate';
import RecordFormEdit from './RecordFormEdit';

/**
 * 上课记录表单包装组件（向后兼容）
 * @deprecated 请直接使用 RecordFormCreate 或 RecordFormEdit
 * 
 * 此组件保留用于向后兼容，新代码应该：
 * - 新增记录：使用 RecordFormCreate
 * - 编辑记录：使用 RecordFormEdit
 */
const RecordFormView = ({ editMode = false, initialData = {}, isSaving = false, onBack, onSave, onDelete }) => {
  // 根据 editMode 渲染对应的专用组件
  if (editMode) {
    return (
      <RecordFormEdit
        initialData={initialData}
        isSaving={isSaving}
        onBack={onBack}
        onSave={onSave}
        onDelete={onDelete}
      />
    );
  }

  return (
    <RecordFormCreate
      isSaving={isSaving}
      onBack={onBack}
      onSave={onSave}
    />
  );
};

export default RecordFormView;
